import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styledRN } from '../styled';
import React from 'react';
import { Dimensions, View } from 'react-native';
import Animated, { Easing as RAEasing, useSharedValue, withTiming, } from 'react-native-reanimated';
import { SAV } from '../sav';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { Directions, Gesture, GestureDetector, } from 'react-native-gesture-handler';
import { CircleButtonNative } from '../circle-button/circle-button-native';
import { WebPortal } from '../web-portals';
import { ZIndexContext } from '../layering';
export const easing = RAEasing.bezier(0.1, 0.12, 0.1, 0.95);
const Container = styledRN(View, ({ $theme }) => ({
    backgroundColor: $theme.background1,
    height: '100%',
    padding: 16,
}));
const HeaderContainer = styledRN(View, {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 15,
});
const ModalContents = styledRN(View, {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
});
/**
 * Contains an exit button for closing
 * @Props onClose: function to call when the exit button is pressed
 */
export const ModalNative = React.memo(function ModalNative(props) {
    const translateY = useSharedValue(Dimensions.get('window').height);
    const parentModalZIndex = React.useContext(ZIndexContext);
    const zIndex = parentModalZIndex + 1;
    React.useEffect(() => {
        translateY.value = withTiming(0, { duration: 300, easing });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onClose = React.useCallback(() => {
        translateY.value = withTiming(Dimensions.get('window').height, {
            duration: 300,
            easing,
        });
        setTimeout(props.onClose, 300);
    }, [props.onClose, translateY]);
    const fling = Gesture.Fling().direction(Directions.DOWN).onEnd(onClose);
    return (_jsx(WebPortal, { children: _jsx(ZIndexContext.Provider, { value: zIndex, children: _jsx(GestureDetector, { gesture: fling, children: _jsx(Animated.View, { style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        height: '100%',
                        width: '100%',
                        zIndex,
                        backgroundColor: 'green',
                        transform: [{ translateY: translateY }],
                    }, children: _jsx(Container, { children: _jsx(SAV, { children: _jsxs(ModalContents, { children: [_jsxs(HeaderContainer, { children: [_jsx(CircleButtonNative, { icon: faTimes, onClick: onClose, size: 40 }), props.header] }), _jsx(View, { style: { height: 15 } }), _jsx(View, { style: { height: 0, flexGrow: 1 }, children: props.children })] }) }) }) }) }) }) }));
});
